const UPPERCASE_WORDS = new Set(["co", "llc", "inc", "usa", "po", "hoa"]);

function capWord(word) {
  const raw = String(word || "");
  const letters = raw.replace(/[^A-Za-z]/g, "");
  if (!letters) return raw;
  const lowerLetters = letters.toLowerCase();
  if (UPPERCASE_WORDS.has(lowerLetters)) return raw.replace(/[A-Za-z]+/, lowerLetters.toUpperCase());
  return raw.replace(/[A-Za-z]+/, (match) => match.charAt(0).toUpperCase() + match.slice(1).toLowerCase());
}

export function standardizeCapitalization(value) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (!text) return "";
  return text
    .split(" ")
    .map((part) =>
      part
        .split(/([-/])/)
        .map((piece) => (piece === "-" || piece === "/" ? piece : capWord(piece)))
        .join("")
    )
    .join(" ")
    .replace(/\b([A-Z][a-z]+),\s*([A-Za-z]{2})\b/g, (_m, city, state) => `${city}, ${state.toUpperCase()}`)
    .replace(/\b(Co|LlC|Llc|Inc|Usa)\b/g, (m) => m.toUpperCase());
}
